import {AccountId, Source} from '@raison/types';
import {Decoder} from '@raison/prelude';
import {TokenAccount} from '~/shared/api/legacy_services/Assets/Assets';
import defaultIcon from '~/shared/legacy_res/img/svg/default.svg';
import {OperableAccount} from './OperableTarget';

export const defaultIconUrl = Decoder.run(Source, `${defaultIcon}`).orThrow();

export interface AccountLike extends AccountLike.Identity, Omit<OperableAccount, keyof OperableAccount.Identity> {}

export namespace AccountLike {
    export type Identity = {
        id: AccountId;
        type: string;
    };
}

export interface AccountLikeToken extends AccountLike {
    type: 'token';
    status: string;
}

export namespace AccountLikeToken {
    export const fromTokenAccount = (token: TokenAccount): AccountLikeToken => ({
        id: token.id,
        type: 'token',
        icon: token.icon ?? defaultIconUrl,
        balance: token.balance,
        balanceIn: token.balance_in,
        balanceOut: token.balance_out,
        currencyCode: token.currency,
        currencyDecimals: token.decimals,
        currencyName: token.name,
        status: token.status,
        providerId: null,
    });
}
